import { configureStore } from '@reduxjs/toolkit';
import { CalendarReducer } from './calendar.feature';
import { CriteriaReducer } from './criteria.feature';
import { RegulationReducer } from './regulation.feature';
import { UserReducer } from './user.feature';
import { VesselReducer } from './vessel.feature';
import { ShowGuidelinesReducer } from './showGuidelines.feature';

export const store = configureStore({
    reducer: {
        User: UserReducer,
        Criteria: CriteriaReducer,
        Regulation: RegulationReducer,
        Vessel: VesselReducer,
        Calendar: CalendarReducer,
        ShowGuidelines: ShowGuidelinesReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
